@import '../../../globals/main.scss';

pn-find-price {
  .sizeTable {
    background-color: transparent !important;
    border-style: none !important;
    border: 0 !important;
    position: relative;

    > tr td {
      margin-bottom: 1em;
      text-align: center;
      vertical-align: bottom;
      padding-right: 1em;
      padding-top: 1em;
    }

    #clouds {
      position: absolute;
      top: 0em;
      left: 4em;
      z-index: -1;
    }
  }

  .firstCell {
    margin-right: 0;
    margin-left: auto;
  }

  .findprice-form {
    max-width: 60em;
    margin: 0em auto 3em auto;

    fieldset {
      border: none;
    }
  }
  [slot='title'] {
    margin-bottom: 1rem;
  }
  h2 {
    text-align: center;
  }
  .heading {
    text-align: center;
    line-height: 1.1;
    font-weight: bold;
    margin-bottom: 1rem;
    color: $blue700;
  }

  .resultHeading {
    text-align: center;
    font-size: 1.5em;
    line-height: 1.1;
    font-weight: bold;
    margin-bottom: 2em;
  }

  .sizecategory {
    margin-top: 1em;
    margin-bottom: 3rem;
    font-size: 0.9em;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .weightoption {
    font-size: 0.9em;

    max-width: 41rem;
    margin: 0 auto;
  }
  .weightoption-content {
    text-align: center;
    pn-choice-button {
      width: 7em;
      line-height: 3.3em;
      font-size: 0.9em;
      vertical-align: bottom;
      > label {
        align-content: center;
        justify-content: center;
      }
      ::before {
        content: 'Max \a0';
        font-weight: lighter;
      }
    }
  }

  .resultlist {
    margin: 3.2rem 0;
  }

  .servicePoint {
    text-align: center;

    pn-illustration {
      display: block;
      max-width: 5em;
      max-height: 5em;
      margin: 1.5em auto 0 auto;
    }

    h3 {
      margin-top: 0.8em;
      margin-bottom: 0.9em;
    }

    a {
      color: $blue700;
      text-decoration: none;
      &:hover {
        color: $blue900;
        text-decoration: underline;
      }
    }
  }
}
